import {UserImageRightsStore} from './image-rights/UserImageRightsStore';

export const stores = [
  UserImageRightsStore
];



// WEBPACK FOOTER //
// ./src/shared/stores/user/index.js